import { FC, useEffect, useState } from 'react';
import { Dialog, DialogContent } from './ui/dialog';

const appealMessages = [
  'Hang tight, we’re updating your info...',
  'Saving your settings...',
  'Making things just right...',
  'Almost done...',
  'Adding final touches...',
];

interface Props {
  show: boolean;
  messages?: string[];
}

const LoadingModal: FC<Props> = ({ show, messages }) => {
  const [appealStage, setAppealStage] = useState(0);

  useEffect(() => {
    const messageInterval = setInterval(() => {
      setAppealStage((prevStage) => {
        if (prevStage < 3) {
          return prevStage + 1;
        }
        return 4;
      });
    }, 5000);

    return () => {
      clearInterval(messageInterval);
    };
  }, []);

  return (
    <Dialog open={show} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md" hideClose>
        <div className="p-6 border border-tax-borderGray rounded-lg bg-white text-center">
          <div className="mb-4 text-2xl">{appealStage <= 3 ? '⚙️' : '✅'}</div>
          <h3 className="text-xl font-medium mb-2">
            {(messages ?? appealMessages)[appealStage]}
          </h3>
          <div className="w-full bg-gray-200 h-2 rounded-full mt-4">
            <div
              className="h-2 bg-tax-brightBlue rounded-full transition-all duration-300"
              style={{
                width: `${
                  ((appealStage + 1) / (messages ?? appealMessages).length) *
                  100
                }%`,
              }}
            ></div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LoadingModal;
